<template>
  <el-row>
    <el-col>
      <div v-loading="isLoading">
        <el-card shadow="never">
          <Invocing
            v-if="carrier"
            ref="invocing"
            :form-data="carrier"
          />
        </el-card>
      </div>
    </el-col>
  </el-row>
</template>
<script>
import Invocing from '@/components/Application/Manage/Carriers/Carrier/ReconciliationInvoicing'
export default {
  components: {
    Invocing
  },
  data () {
    return {
      title: 'Invoice',
      breadcrumb: {
        name: 'Invoice',
        route: { name: 'manage-carriers-carrier-configurations-invoice' }
      },
      actions: [
        {
          name: 'Save',
          icon: ['fal', 'save'],
          event: this.save
        }
      ],
      isSaving: false,
      isLoading: false,
      carrier: null
    }
  },
  mounted () {
    this.loadCarrierById()
  },
  methods: {
    loadCarrierById () {
      this.isLoading = true
      this.$sdk.carrier.read(this.$route.params.carrierId, (builder) => {
        builder.include = ['default_fuel_group.fuels', 'default_service']
      }).then(res => { this.carrier = res })
        .finally(() => { this.isLoading = false })
    },
    save () {
      this.isSaving = true
      this.carrier.update(builder => {
        builder.include = ['default_fuel_group.fuels', 'default_service']
      })
        .then(() => this.$message({ message: 'Successfully saved', type: 'success' }))
        .finally(() => { this.isSaving = false })
    }
  }
}
</script>
